import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import SourceFlowForm from '@sourceflow-uk/sourceflowform';
import {
    Container,
} from 'reactstrap';
import styles from './styles.module.scss';

export default function NewColumnTextWithForm({
    customClass = "",
    formId,
    locale,
    successPageUrl = `${locale == "us" ? "/us/submission-success" : "/submission-success"}`,
    global,
    content,
    pathPrefix
}) {
    return (
        <>
            <div id="contactForm" className={`${styles.root} ${customClass}`}>
                <Container>
                    <div className="d-flex gap-5 flex-wrap flex-lg-nowrap">
                        <div className="column">
                            <SourceFlowText global={global} path={`${pathPrefix}.content`} type="text">
                                {content}
                            </SourceFlowText>
                        </div>
                        <div className="column">
                            {formId ?
                                <SourceFlowForm
                                    formId={formId}
                                    onSubmitDone={() => (window.location.href = successPageUrl)}
                                /> : ""}
                        </div>
                    </div>
                </Container>
            </div>
        </>
    )
}